var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 9.61616C6 8.72404 6.72404 8 7.61616 8H24.3838C25.276 8 26 8.72404 26 9.61616C26 10.5083 25.276 11.2323 24.3838 11.2323H7.61616C6.72404 11.2323 6 10.5083 6 9.61616ZM24.3838 14.8687H7.61616C6.72404 14.8687 6 15.5927 6 16.4848C6 17.377 6.72404 18.101 7.61616 18.101H24.3838C25.276 18.101 26 17.377 26 16.4848C26 15.5927 25.2768 14.8687 24.3838 14.8687ZM24.3838 21.7374H7.61616C6.72404 21.7374 6 22.4614 6 23.3535C6 24.2457 6.72404 24.9697 7.61616 24.9697H24.3838C25.276 24.9697 26 24.2457 26 23.3535C26 22.4614 25.2768 21.7374 24.3838 21.7374Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.92898e44f978ab38e82b0a83ae5596f1.svg";
export { ForwardRef as ReactComponent };